<div class="form-inner-box w-100">
  <h4 class="text-capitalize position-relative pt-3 text-primary">
    Glade to See you!
  </h4>
  <p class="link-txt text-primary">
    Create an account on
    <span class="text-secondary text-capitalize">wellness safari</span>
  </p>
  <form [formGroup]="addUser" (ngSubmit)="saveUserData()">
    <div class="row">
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="first_name" class="form-control mb-3"
          placeholder="First Name" />
        @if ( (first_name?.touched || first_name?.dirty || submitted ) &&
        !first_name?.valid && !first_name?.pending ) {
        @if(first_name?.errors.required){
        <span class="text-danger error">First Name is required</span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="last_name" class="form-control mb-3" placeholder="Last Name" />

        @if ((last_name?.touched || last_name?.dirty || submitted) &&
        !last_name?.valid && !last_name?.pending) {
        @if(last_name?.errors.required){
        <span class="text-danger error">Last is required</span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="email" class="form-control mb-3" placeholder="Email" />

        @if ((email?.touched || email?.dirty || submitted) && !email?.valid &&
        !email?.pending) {
        <span class="text-danger error">
          @if(email?.errors.required) { Email is required }
          @if(email?.errors.pattern) { Please Fill Proper Email }
        </span>
        }
      </div>

      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="hear_about_us" class="form-control mb-3"
          placeholder="How did you hear about us?" />
      </div>
      <div class="col-md-6 px-2">
        <div class="pwd-box">
          <input [type]="showHidePassword?'text':'password'" formControlName="password" class="form-control mb-3"
            placeholder="Password" />
          <!-- <span class="cursor-pointer"><i class="fa-solid fa-eye"></i><i class="fa-solid fa-eye-slash"></i></span> -->
          <span class="cursor-pointer"><i (click)="passwordShowHide()" class="fa-solid"
              [ngClass]="showHidePassword?'fa-eye-slash':'fa-eye'"></i></span>
        </div>
        @if ((password?.touched || password?.dirty || submitted) &&
        !password?.valid && !password?.pending) {
        <span class="text-danger error">
          @if(password?.errors.required) { Password is required }
          @if(password?.errors.minlength) { Minimum 6 characters required }
          @if(password?.errors.maxlength) { Maximum 20 characters allowed }
        </span>
        }
      </div>
      <div class="col-md-6 px-2">
        <div class="pwd-box">
          <input [type]="showHideConfirmPassword?'text':'password'" formControlName="password_confirmation"
            class="form-control mb-3" placeholder="Confirm Password" />
          <!-- <span class="cursor-pointer"><i class="fa-solid fa-eye"></i><i class="fa-solid fa-eye-slash"></i></span> -->
          <span class="cursor-pointer"><i (click)="confirmPasswordShowHide()" class="fa-solid"
              [ngClass]="showHideConfirmPassword?'fa-eye-slash':'fa-eye'"></i></span>
        </div>
        @if ((password_confirmation?.touched || password_confirmation?.dirty ||
        submitted) && !password_confirmation?.valid &&
        !password_confirmation?.pending) {
        <span class="text-danger error">
          @if(password_confirmation?.errors.required) { Confirm Password is
          required } @if(password_confirmation?.errors.mustMatch) { Confirm
          Password Does not match With Password }
        </span>
        }
      </div>

      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="phone_no" class="form-control mb-3"
          placeholder="Mobile Number" />

        @if ((phone_no?.touched || phone_no?.dirty || submitted) &&
        !phone_no?.valid && !phone_no?.pending) {
        <span class="text-danger error">
          @if(phone_no?.errors.required) { Mobile Number is required }
          @if(phone_no?.errors.pattern) { Please enter numerals only (no-dashes)
          } @if(phone_no?.errors.minlength) { Minimum 6 digits required }
          @if(phone_no?.errors.maxlength) { Maximum 15 digits allowed }
        </span>
        }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="home_phone" class="form-control mb-3"
          placeholder="Home Phone Number" />

        @if ((home_phone?.touched || home_phone?.dirty || submitted) &&
        !home_phone?.valid && !home_phone?.pending) {
        @if(home_phone?.errors.pattern) {
        <span class="text-danger error">
          Please enter numerals only (no-dashes)
        </span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="country" class="form-control mb-3" placeholder="Country" />
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="state" class="form-control mb-3" placeholder="State" />

        @if ((state?.touched || state?.dirty || submitted) && !state?.valid &&
        !state?.pending) { @if(state?.errors.required) {
        <span class="text-danger error"> State is required </span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="city" id="" class="form-control mb-3" placeholder="City" />

        @if ((city?.touched || city?.dirty || submitted) && !city?.valid &&
        !city?.pending) { @if(city?.errors.required) {
        <span class="text-danger error"> City is required </span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="zipcode" class="form-control mb-3" placeholder="Zip Code" />

        @if ( (zipcode?.touched || zipcode?.dirty || submitted) &&
        !zipcode?.valid && !zipcode?.pending) {
        <span class="text-danger error">
          @if(zipcode?.errors.required) { Zipcode is required }
          @if(zipcode?.errors.pattern) { Zipcode should be a number }
          @if(zipcode?.errors.minlength) { Minimum 5 digits required }
          @if(zipcode?.errors.maxlength) { Maximum 9 digits allowed }
        </span>

        }
      </div>
      <div class="col-md-6 px-2">
        <textarea trim="blur" formControlName="address" rows="2" class="form-control mb-3" placeholder="Address">
        </textarea>

        @if ((address?.touched || address?.dirty || submitted) &&
        !address?.valid && !address?.pending) { @if(address?.errors.required) {
        <span class="text-danger error"> Address is required </span>
        } }
      </div>
      <div class="col-md-6 px-2">
        <input type="text" trim="blur" formControlName="tdl" class="form-control mb-3" placeholder="TDL Number" />

        @if ((tdl?.touched || tdl?.dirty || submitted) && !tdl?.valid &&
        !tdl?.pending) { @if(tdl?.errors.pattern) {
        <span class="text-danger error"> TDL should be a number </span>
        } }
      </div>

      <div class="col-xl-12 px-2 mb-2">
        <div class="link-txt text-primary d-flex">
          <input type="checkbox" class="form-check-input mt-0" id="term_condition" formControlName="term_condition" />
          <label class="small-text" class="form-check-label ms-2">By registering, I agree to
            <a href="https://www.safarivet.com/" class="link-info link cursor-pointer" target="_blank">Terms and
              Conditions</a></label>
        </div>
        @if ((term_condition?.touched || term_condition?.dirty || submitted) &&
        !term_condition?.valid && !term_condition?.pending) { @if(term_condition?.errors.required) {
        <span class="text-danger error mt-3"> Accept terms and
          conditions to continue </span>
        } }
      </div>


      <div class="d-flex justify-content-between align-items-center flex-column flex-md-row">
        <div class="link-txt text-primary">
          Already have an account?
          <a href="" class="link-info link" [routerLink]="['/login']">Sign In</a>
        </div>
        <button class="btn btn-success mt-3 mt-md-0" type="submit">
          Register Now
        </button>
      </div>
    </div>
  </form>
</div>